import React, { useEffect, useState } from 'react';
import StAddNew from './DSeries/StAddNew';
import { Button, Col, Form, Modal, Row, message } from 'antd';
import { useSelector } from 'react-redux';
import liracrypt from '../components/Liracrypt/liracrypt';
import SparkTable from './InputCreater/SparkTable';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';

const SparkTableBuilder = ({
    setPageHeader
}) => {
    const smodalDictName = {
        'upload-file': 'SparkTable_FileUpload',
        'upload-json': 'ZenFormBuilder_jsonUploader',
        'edit-cell': 'SparkTableBuilder_editCell',
        'edit-header': 'SparkTableBuilder_editHeader',
    }
    const [dictForm] = Form.useForm();
    const [pageConfig, setPageConfig] = useState();
    const [modalTitle, setModalTitle] = useState('');
    const [form] = Form.useForm();
    const [sparkTableData, setSparkTableData] = useState();
    const urlCode = useSelector(state => state.urlCode);
    const [uploadModal, setUploadModal] = useState({
        open: false,
        typ: '',
        modalData: null,
        loading: false
    });
    const openModal = ({ typ, modalData }) => {
        setUploadModal({
            open: true,
            typ,
            modalData,
            loading: false
        })
    };

    const closeModal = () => {
        setUploadModal({
            open: false,
            typ: '',
            modalData: null,
            loading: false
        })
    };


    useEffect(() => {
        setPageHeader('Spark Table Builder')
    }, []);


    const downloadFile = () => {
        liracrypt.get('/sparktable/download', { typ1: 'sparkTable', dictName: pageConfig?.data?.config?.dictName, pageconfigId: pageConfig?.data?.config?._id }).then(({ data }) => {
            if (data.isSuccess) {
                window.open(
                    `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
                    '_blank'
                )
            } else {
                message.error(data.message);
            }
        })
    }

    const uploadFile = (values) => {
        let formData = new FormData();
        formData.append('dictName', pageConfig?.data?.config?.dictName);
        formData.append('pageconfigId', pageConfig?.data?.config?._id);
        formData.append('typ1', 'sparkTable');
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        });
        let dictFormData = dictForm.getFieldsValue();
        Object.keys(dictFormData).forEach(x => {
            formData.append(x, dictFormData[x]);
        });
        liracrypt.uploadFile(uploadModal.typ === 'upload-json' ? '/sparktablejson/upload' : '/sparktable/upload', formData)
            .then(({ data }) => {
                console.log(data);
                // setSmodalLoading(false);
                if (data.isSuccess) {
                    setPageConfig(null);
                    setTimeout(() => {
                        dictForm.submit();
                        closeModal();
                    }, 500);
                    //    message.success(data.message || 'Successfully Saved');
                } else {
                    message.success(data.message || 'Something went wrong');
                }
            }).catch(err => {
                //  setSmodalLoading(false);
                console.log(err);
                message.error('Something went wrong');
            })
    }

    const updateCell = (values) => {
        if (values.typ === 'dropDown') {
            if (values.source === 'mdict') {
                values.sourceParams = {
                    typ: values.sourceParams_mdict,
                    subTyp: 'idame'
                }
            }

            if (values.source === 'cropdown') {
                values.sourceParams = {
                    name: values.sourceParams_cropdown,
                    // subTyp: 'idame'
                }
            }
        };
        liracrypt.patch('/spark/table', { ...uploadModal.modalData, ...values, dictName: pageConfig?.data?.config?.dictName, _id: pageConfig?.data?.config?._id })
            .then(response => {
                if (response.data.isSuccess) {
                    dictForm.submit();
                    closeModal();
                    message.success(response.data.message || 'Updated Successfully');
                } else {
                    message.error(response.data.message || 'Something went wrong');
                }

            }).catch(err => {
                ApiErrorComp();
                setUploadModal({
                    ...uploadModal,
                    loading: false
                })
                console.log(err);
            })
    }


    const submitSmodal = (values) => {
        setUploadModal({
            ...uploadModal,
            loading: true
        });
        if (uploadModal.typ === 'edit-cell') {
            return updateCell({ ...values, editTyp: 'row', cellStyle: {} });
        };
        if (uploadModal.typ === 'edit-header') {
            return updateCell({ ...values, editTyp: 'header' });
        };
        return uploadFile(values);
    }

    return (
        <div className='phantom-form stable-builder'>
            <StAddNew
                initForm={dictForm}
                colSpan={12}
                stopResetForm={true}
                urlEndpoint="/miscellaneous/pageconfig"
                urlData={{ dictName: "SparkTableBuilderQuery" }}
                extraData={{}}
                onCallFinish={({ data }) => {
                    console.log(data);
                    setPageConfig(data);
                    //setSparkTableData(data);
                    // setControlTyp('all');
                }}
            />
            {
                pageConfig ?
                    <div>
                        <div className='stable-builder-btns' style={{ padding: 10, marginTop: 20, display: 'inline-flex', flexWrap: 'wrap', width: '100%' }}>
                            <Button ghost={true} style={{ marginRight: 10, marginBottom: 0 }} type="primary" onClick={downloadFile}>
                                Download File
                            </Button>
                            <Button ghost={true} style={{ marginRight: 10, marginBottom: 0 }} type="primary" onClick={() => openModal({ typ: 'upload-file' })}>
                                Upload CSV File
                            </Button>
                            <Button ghost={true} style={{ marginRight: 10, marginBottom: 0 }} type="primary" onClick={() => openModal({ typ: 'upload-json' })}>
                                Upload JSON File
                            </Button>
                            {/* <a className='ant-btn ant-btn-primary' target='_blank' href={`/v02/${localStorage.getItem('urlCode')}/stable-preview?_id=${pageConfigData?.config?.pageconfigId}&dictName=${pageConfigData?.config?.dictName}`}>
                        Preview Stable
                    </a> */}
                        </div>
                        <div>
                            <div className={'customer-complaint'} style={{ padding: "10px" }}>
                                <div className="customer-form">
                                    <Row style={{ position: 'relative' }}>
                                        <Col span={24}>
                                            <Form
                                                name="SparkTableBuilder"
                                                labelWrap={true}
                                                form={form}
                                                labelCol={{ span: 8 }}
                                                colon={false}
                                                onFinish={() => { }}
                                                size="large"
                                            >
                                                {/* <div className='spark-builder-overlay'></div> */}
                                                <SparkTable
                                                    onCellEdit={({ data, typ }) => openModal({
                                                        typ: typ,
                                                        modalData: data
                                                    })}
                                                    builder={true}
                                                    tableData={pageConfig?.data}
                                                    LocalDict={[]}
                                                    label={""}
                                                    labelCol={8}
                                                    form={form}
                                                    // api={"/kei/sparktable"}
                                                    // params={{
                                                    //     "dn": "Qcp104ExtrusionInsHtTable"
                                                    // }}
                                                    colSpan={17}
                                                //  layoutPosition={layoutPosition}
                                                />
                                            </Form>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div> : <></>
            }

            {
                uploadModal.open && (
                    <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={uploadModal.open} title={modalTitle || "Upload File"} onCancel={closeModal}>
                        <StAddNew
                            dropdownExtraData={{ stdid: pageConfig?.data?.config?.stdid }}
                            urlMethod={(uploadModal.typ === 'edit-cell' || uploadModal.typ === 'edit-header') ? "POST" : "GET"}
                            urlEndpoint={(uploadModal.typ === 'edit-cell' || uploadModal.typ === 'edit-header') ? "/smodal/zenform" : "/smodal"}
                            formName="UploadSparkTable"
                            setSmodalTitle={title => { setModalTitle(title) }}
                            urlData={{
                                ...uploadModal.modalData,
                                dictName: smodalDictName[uploadModal.typ]
                            }}
                            colSpan={24}
                            onFormSubmit={submitSmodal}
                        />
                        <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                            <Button loading={uploadModal.loading} htmlType='submit' type="primary" form={'UploadSparkTable'}>Submit</Button>
                        </div>
                    </Modal>

                )
            }
        </div>
    )
};

export default SparkTableBuilder;